/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeedbackMessages
 */
export interface FeedbackMessages {
    /**
     * 
     * @type {string}
     * @memberof FeedbackMessages
     */
    requested?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackMessages
     */
    received?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackMessages
     */
    closed?: string;
}

export function FeedbackMessagesFromJSON(json: any): FeedbackMessages {
    return FeedbackMessagesFromJSONTyped(json, false);
}

export function FeedbackMessagesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackMessages {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'requested': !exists(json, 'requested') ? undefined : json['requested'],
        'received': !exists(json, 'received') ? undefined : json['received'],
        'closed': !exists(json, 'closed') ? undefined : json['closed'],
    };
}

export function FeedbackMessagesToJSON(value?: FeedbackMessages | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'requested': value.requested,
        'received': value.received,
        'closed': value.closed,
    };
}

